import React, { useEffect, useState } from 'react';
import { getAuditLogs, getAuditStats } from '../services/api';

const AuditLogs: React.FC = () => {
  const [logs, setLogs] = useState<any[]>([]);
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ module: '', action: '', status: '', date_debut: '', date_fin: '', search: '' });

  useEffect(() => { loadAll(); }, []);
  useEffect(() => { loadLogs(); }, [filters]);

  const loadAll = async () => {
    try {
      const [logsRes, statsRes] = await Promise.all([getAuditLogs({}), getAuditStats()]);
      setLogs(logsRes.data);
      setStats(statsRes.data);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const loadLogs = async () => {
    try {
      const params: any = {};
      Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v; });
      const res = await getAuditLogs(params);
      setLogs(res.data);
    } catch (err) { console.error(err); }
  };

  return (
    <div>
      <div className="page-header">
        <h2>Journal d'Audit</h2>
        {stats && <span className="badge">{stats.total} evenements</span>}
      </div>

      {/* Stats cards */}
      {stats && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 20 }}>
          <div className="card" style={{ padding: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase' }}>Total</div>
            <div style={{ fontSize: 24, fontWeight: 700, color: '#004A97' }}>{stats.total}</div>
          </div>
          <div className="card" style={{ padding: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase' }}>Erreurs</div>
            <div style={{ fontSize: 24, fontWeight: 700, color: '#ED0000' }}>{stats.erreurs}</div>
          </div>
          {stats.parModule?.slice(0, 3).map((m: any) => (
            <div key={m.module} className="card" style={{ padding: 16, textAlign: 'center' }}>
              <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase' }}>{m.module}</div>
              <div style={{ fontSize: 24, fontWeight: 700, color: '#3c3c3c' }}>{m.total}</div>
            </div>
          ))}
        </div>
      )}

      {/* Filters */}
      <div className="filters" style={{ marginBottom: 16 }}>
        <select value={filters.module} onChange={e => setFilters({ ...filters, module: e.target.value })}>
          <option value="">Tous les modules</option>
          {stats?.parModule?.map((m: any) => <option key={m.module} value={m.module}>{m.module}</option>)}
        </select>
        <select value={filters.action} onChange={e => setFilters({ ...filters, action: e.target.value })}>
          <option value="">Toutes les actions</option>
          {stats?.parAction?.map((a: any) => <option key={a.action} value={a.action}>{a.action}</option>)}
        </select>
        <select value={filters.status} onChange={e => setFilters({ ...filters, status: e.target.value })}>
          <option value="">Tous statuts</option>
          <option value="success">Succes</option>
          <option value="error">Erreur</option>
        </select>
        <input type="date" value={filters.date_debut} onChange={e => setFilters({ ...filters, date_debut: e.target.value })} />
        <input type="date" value={filters.date_fin} onChange={e => setFilters({ ...filters, date_fin: e.target.value })} />
        <input type="text" value={filters.search} onChange={e => setFilters({ ...filters, search: e.target.value })} placeholder="Rechercher..." onKeyDown={e => e.key === 'Enter' && loadLogs()} />
      </div>

      {loading ? <div className="loading">Chargement...</div> : (
        <table className="table">
          <thead>
            <tr><th>Date</th><th>Utilisateur</th><th>Role</th><th>Action</th><th>Module</th><th>Description</th><th>Statut</th><th>IP</th></tr>
          </thead>
          <tbody>
            {logs.map((l: any) => (
              <tr key={l.id}>
                <td style={{ whiteSpace: 'nowrap' }}>{new Date(l.created_at).toLocaleString('fr-FR')}</td>
                <td>{l.user_prenom} {l.user_nom}<br /><span style={{ fontSize: 11, color: '#888' }}>{l.user_email}</span></td>
                <td><span className="badge badge-info">{l.user_role}</span></td>
                <td><strong>{l.action}</strong></td>
                <td>{l.module}</td>
                <td style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.description}</td>
                <td><span className={`badge badge-${l.status === 'success' ? 'success' : 'critical'}`}>{l.status}</span></td>
                <td style={{ fontSize: 11, color: '#888' }}>{l.ip_address}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={8} style={{ textAlign: 'center', padding: 30 }}>Aucun log</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AuditLogs;
